import axios from 'axios'
import Vue from 'vue'

export const groupAccessState = Vue.observable({ revision: 0 })

// Group pages and their shared links send viewers here; single-client and retailer pages keep events@.
export const GROUP_CONTACT_EMAIL = 'tastings@hspbrands.com'

export function captureGroupLink (location = window.location, stripUrl = true) {
  const match = location.pathname.match(/^\/groups\/([a-z0-9-]{1,40})\/?$/)
  if (!match) return false
  const token = new URLSearchParams(location.hash.slice(1)).get('access_key')
  if (token === null) return false
  if (/^[a-f0-9]{64}$/.test(token)) {
    window.sessionStorage.setItem(`group-access:${match[1]}`, token)
  } else {
    window.sessionStorage.removeItem(`group-access:${match[1]}`)
  }
  groupAccessState.revision++
  if (stripUrl) window.history.replaceState(null, '', location.pathname + location.search)
  return true
}

export function groupToken (code) {
  return window.sessionStorage.getItem(`group-access:${code}`) || ''
}

export function clearGroupToken (code) {
  window.sessionStorage.removeItem(`group-access:${code}`)
}

export function groupGet (apiRoot, code, token, path = '', params = {}, responseType = 'json') {
  return axios.get(`${apiRoot}groups/${encodeURIComponent(code)}${path}`, {
    params,
    responseType,
    headers: { Authorization: `Bearer ${token}` }
  })
}

export function calendarDays (start, end) {
  if (!start || !end || start > end) return []
  const days = []
  let cursor = new Date(`${start}T00:00:00Z`)
  const last = new Date(`${end}T00:00:00Z`)
  while (cursor <= last && days.length < 93) {
    days.push({
      date: cursor.toISOString().slice(0, 10),
      label: cursor.toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' }),
      weekday: cursor.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' }),
      monday: cursor.getUTCDay() === 1
    })
    cursor = new Date(cursor.getTime() + 86400000)
  }
  return days
}

// Drops the distributor prefix, e.g. "Breakthru Beverage AZ - Gallo" becomes "Gallo"
export function supplierName (name) {
  const text = String(name || '')
  // Agency accounts are named "3PA - <supplier> - [Agency ]<agency>".
  const agency = text.match(/^3PA\s+-\s+(.+?)\s+-\s+[^-]+$/)
  return agency ? agency[1] : text.replace(/^.+?\s+-\s+/, '')
}

export function csvText (rows) {
  return rows.map(row => row.map(value => {
    let text = value == null ? '' : String(value)
    if (/^[\s]*[=+@-]/.test(text)) text = "'" + text
    return '"' + text.replace(/"/g, '""') + '"'
  }).join(',')).join('\r\n')
}

export function downloadCsv (filename, rows) {
  const url = URL.createObjectURL(new Blob(['\ufeff' + csvText(rows)], { type: 'text/csv;charset=utf-8' }))
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}

export function groupPost (apiRoot, code, token, path, data) {
  return axios.post(`${apiRoot}groups/${encodeURIComponent(code)}${path}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  })
}

export function scheduleCsv (events, { storeLabel = '', state = '' } = {}) {
  const zone = state || 'local time'
  return [['Event Type', 'Product', 'Substitutions', 'Store Name', 'Store #', 'Date', `Start (${zone})`, `End (${zone})`, 'City', 'State', 'Retailer', 'Work Order', 'Supplier']].concat(events.map(event => [
    scheduleEventType(event),
    event.wines.join('; '), event.sub_wines.join('; '), event.storename, event.warehouse_id,
    event.schedule_date, event.time_start, event.time_end, event.city, event.state, storeLabel, event.work_order, event.client_name
  ]))
}

export function scheduleEventType (event) {
  const code = (event.sub_code || '').toLowerCase()
  const labels = { samb: 'Gold Tasting', samp: 'Sampling Event', boost: 'SipBoost', digb: 'SipBoost', sipa: 'SipBoost', brand: 'SipSavvy', '3pa': '3P Tasting Event', '3psam': '3P Tasting Event', '3psm': '3P Tasting Event', '3pse': '3P Tasting Event' }
  return (labels[code] || 'Event') + (event.pending ? ' (Pending approval)' : '')
}

export function downloadFile (filename, blob) {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}
